import { createStructuredSelector } from 'reselect';
import { applicantTypeSelector } from '../../store/applicant/selectors';

const mainDataSelector = createStructuredSelector({
  applicantType: applicantTypeSelector
});

export default mainDataSelector;
